import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicationInformationDetails from './AppicationInformationDetails';
import HouseholdIncomeDetails from './HouseholdIncomeDetails';
import Scope from './Scope';

export const CRApplicationDetails = ({ applicationData }: IApplicationDetails) => {
  return (
    <>
      <ApplicationInformationDetails applicationInformation={applicationData.application} />
      <HouseholdIncomeDetails householdIncome={applicationData?.householdIncome} />
      <Scope scope={applicationData.scope} />
    </>
  );
};
